import {Kelly} from './Kelly';
import CustomerDesktopBase from '../CustomerDesktopBase';

export class CustomerDesktopKelly extends Kelly {

    constructor() {
        super();
        this.setKellyCustomerColors();
    };

    private setKellyCustomerColors (): void {
        const kellyGrey = '#333';
        const kellyGreen = '#00B142';
        const kellyGreenAlt = '#378944';

        this.colors.general.primaryColor = kellyGreen;
        this.colors.general.secondaryColor = kellyGrey;
        this.colors.general.tertiaryColor = kellyGreen
        this.colors.general.blueDarkColor = kellyGreen;

        this.colors.hover.primaryHoverColor = kellyGreenAlt;
        this.colors.background.blueBackgroundColor = kellyGreen;
        this.colors.background.blueHighlightBackgroundColor = 'rgba(0,177,66,0.4)';

        this.colors.ratingStar.ratedColor = kellyGreen;

        this.colors.text.passedTextColor = this.colorPalette.green;
        this.colors.text.successTextMessage = this.colorPalette.greenActive;
        this.colors.text.errorTextMessage = this.colorPalette.red;

        this.setDeprecatedKellyCustomerColors();
    };

    private setDeprecatedKellyCustomerColors (): void {

        /** @deprecated since version 0.2.*, use hover.primaryHoverColor */
        this.colors.general.primaryHoverColor = this.colorPalette.blueDeep;
        /** @deprecated since version 0.2.*, use hover.secondaryHoverColor */
        this.colors.general.secondaryHoverColor = this.colorPalette.grayDarker;

        /** @deprecated since version 0.2.*, use text.errorTextMessage */
        this.colors.general.errorTextMessage = this.colorPalette.red;
        /** @deprecated since version 0.2.*, use text.successTextMessage */
        this.colors.general.successTextMessage = this.colorPalette.greenActive;
    };
}

const customerDesktopKellyTheme = CustomerDesktopBase.setShareStyles(new CustomerDesktopKelly());
export default customerDesktopKellyTheme;



// WEBPACK FOOTER //
// webpack://frontendThemeProvider/src/themes/Kelly/customer-desktop.ts